import React from 'react';
import { warningMessage } from 'src/util/state-helpers';
import { BundleErrors as BundleErrorsTypes } from 'src/types/global-types';

import { Messages } from '../Messages/Messages';

type Props = {
    errors: BundleErrorsTypes;
    totalQty?: number;
    maxQty?: number;
};

export const BundleErrors: React.FC<Props> = ({ errors }) => {
    return (
        <>
            {errors && errors.emptyCustomisation && (
                <Messages messages={[warningMessage(`Please add customisation`)]} />
            )}
            {errors && errors.textError && <Messages messages={[warningMessage(`Please add text to your logo`)]} />}
            {errors && errors.logoError && (
                <Messages messages={[warningMessage(`Please add an image for your logo`)]} />
            )}
            {errors && errors.positionError && (
                <Messages messages={[warningMessage(`Artwork positions cannot be the same as previous logo`)]} />
            )}
        </>
    );
};
